import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/axios';

export function useKnowledgeDocs() {
  return useQuery({
    queryKey: ['knowledge'],
    queryFn: async () => {
      const { data } = await api.get('/knowledge');
      return data;
    },
  });
}

export function useUploadKnowledge() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (file) => {
      const formData = new FormData();
      formData.append('file', file);
      const { data } = await api.post('/knowledge/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['knowledge'] }),
  });
}

export function useDeleteKnowledge() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      const { data } = await api.delete(`/knowledge/${id}`);
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['knowledge'] }),
  });
}
